<!--
  WARNING!

  this file was automatically generated and should be updated using:

  ng g lazy-component extensions/compare/shared/product-send-to-compare/product-send-to-compare.component.ts
-->
<ng-template #anchor></ng-template>
